import { render, staticRenderFns } from "./EditAdminPasswordDialog.vue?vue&type=template&id=e4e9dff6&scoped=true&"
import script from "./EditAdminPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./EditAdminPasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e9dff6",
  null
  
)

export default component.exports